/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-alert */
import React, { useRef } from 'react';
import { DialogUtility } from '@syncfusion/ej2-popups';
// import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import { TextAreaComponent, TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
// import { MultiSelectComponent, DropDownListComponent, CheckBoxSelection, Inject } from '@syncfusion/ej2-react-dropdowns';
import Navbar from './Navbar1';
import Footer1 from './Footer1';
import kit from '../data/w3kit.jpeg';
import EmbeddedForm from './EmbeddedForm';

const Contact = () => {
  const { REACT_APP_API_ENDPOINT } = process.env;
  // const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const demo = searchParams.get('demo');
  /*
  const usServices = [
    { name: 'Water Transfer', abbreviation: 'Water Transfer' },
    { name: 'Water Resourcing', abbreviation: 'Water Resourcing' },
    { name: 'Hydro Vac', abbreviation: 'Hydro Vac' },
    { name: 'Rig Wash', abbreviation: 'Rig Wash' },
    { name: 'Degreaser', abbreviation: 'Degreaser' },
    { name: 'Worker Wearable', abbreviation: 'Worker Wearable' },
  ];
  const usStates = [
    { name: 'Alabama', abbreviation: 'AL' },
    { name: 'Alaska', abbreviation: 'AK' },
    { name: 'American Samoa', abbreviation: 'AS' },
    { name: 'Arizona', abbreviation: 'AZ' },
    { name: 'Arkansas', abbreviation: 'AR' },
    { name: 'California', abbreviation: 'CA' },
    { name: 'Colorado', abbreviation: 'CO' },
    { name: 'Connecticut', abbreviation: 'CT' },
    { name: 'Delaware', abbreviation: 'DE' },
    { name: 'District of Columbia', abbreviation: 'DC' },
    { name: 'Federated States of Micronesia', abbreviation: 'FM' },
    { name: 'Florida', abbreviation: 'FL' },
    { name: 'Georgia', abbreviation: 'GA' },
    { name: 'Guam', abbreviation: 'GU' },
    { name: 'Hawaii', abbreviation: 'HI' },
    { name: 'Idaho', abbreviation: 'ID' },
    { name: 'Illinois', abbreviation: 'IL' },
    { name: 'Indiana', abbreviation: 'IN' },
    { name: 'Iowa', abbreviation: 'IA' },
    { name: 'Kansas', abbreviation: 'KS' },
    { name: 'Kentucky', abbreviation: 'KY' },
    { name: 'Louisiana', abbreviation: 'LA' },
    { name: 'Maine', abbreviation: 'ME' },
    { name: 'Marshall Islands', abbreviation: 'MH' },
    { name: 'Maryland', abbreviation: 'MD' },
    { name: 'Massachusetts', abbreviation: 'MA' },
    { name: 'Michigan', abbreviation: 'MI' },
    { name: 'Minnesota', abbreviation: 'MN' },
    { name: 'Mississippi', abbreviation: 'MS' },
    { name: 'Missouri', abbreviation: 'MO' },
    { name: 'Montana', abbreviation: 'MT' },
    { name: 'Nebraska', abbreviation: 'NE' },
    { name: 'Nevada', abbreviation: 'NV' },
    { name: 'New Hampshire', abbreviation: 'NH' },
    { name: 'New Jersey', abbreviation: 'NJ' },
    { name: 'New Mexico', abbreviation: 'NM' },
    { name: 'New York', abbreviation: 'NY' },
    { name: 'North Carolina', abbreviation: 'NV' },
    { name: 'North Dakota', abbreviation: 'ND' },
    { name: 'Northern Mariana Islands', abbreviation: 'MP' },
    { name: 'Ohio', abbreviation: 'OH' },
    { name: 'Oklahoma', abbreviation: 'OK' },
    { name: 'Oregon', abbreviation: 'OR' },
    { name: 'Palau', abbreviation: 'PW' },
    { name: 'Pennsylvania', abbreviation: 'PA' },
    { name: 'Puerto Rico', abbreviation: 'PR' },
    { name: 'Rhode Island', abbreviation: 'RI' },
    { name: 'South Carolina', abbreviation: 'SC' },
    { name: 'South Dakota', abbreviation: 'SD' },
    { name: 'Tennessee', abbreviation: 'TN' },
    { name: 'Texas', abbreviation: 'TX' },
    { name: 'Utah', abbreviation: 'UT' },
    { name: 'Vermont', abbreviation: 'VT' },
    { name: 'Virgin Island', abbreviation: 'VI' },
    { name: 'Virginia', abbreviation: 'VA' },
    { name: 'Washington', abbreviation: 'WA' },
    { name: 'West Virginia', abbreviation: 'WV' },
    { name: 'Wisconsin', abbreviation: 'WI' },
    { name: 'Wyoming', abbreviation: 'WY' },
  ];

  const fields = {
    text: 'name', // The property to display in the dropdown list
    value: 'abbreviation', // The actual value bound to the component
  };
  */
  /*
  const getData = async () => {
    await axios.get('https://api.ipify.org/?format=json').then((res) => {
      if (res.data && res.data.ip && (!res.data.ip.includes('162.237.130.3') && !res.data.ip.includes('104.183.248.155') && !res.data.ip.includes('63.249.41.231') && !res.data.ip.includes('24.155.131.7'))) {
        navigate('/notfound');
      }
    })
      .catch((error) => {
        console.error(error);
      });
  };
  useEffect(() => {
    // passing getData method to the lifecycle method
    getData();
  }, []);
  */
  async function sendEmail(email, to, subject, message) {
    if (email && email.length > 5 && email.includes('@') && email.includes('.')) {
      fetch(`${REACT_APP_API_ENDPOINT}/email?recipient=${email}&to=${to}&subject=${subject}&message=${message}<br />Monaco Contact Form:<br />Please send me more information`, {
        method: 'GET',
        headers: {
        },
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson && responseJson.response && responseJson.response === 'OK') {
            DialogUtility.alert('Your request has been sent. Thank you for your interest!');
          } else {
            DialogUtility.alert(responseJson.response);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      DialogUtility.alert('Please enter a valid email address!');
    }
  }
  // const multiSelectServices = useRef(null);
  // const stateSelect = useRef(null);
  const messageRef = useRef(null);
  const submitEmail = () => {
    const email = document.getElementById('email').value;
    // const to = 'bbarrs@zackatlabs.com';
    const to = 'info@zackatlabs.com';
    const first = document.getElementById('first').value;
    const last = document.getElementById('last').value;
    const phone = document.getElementById('phone').value;
    // const company = document.getElementById('company').value;
    const subject = 'Heat Stress Interest Form';
    const name = `${first} ${last}`;
    // const location = '';
    // const services = '';
    let msg = '';
    if (!email || email.length === 0 || !email.includes('@') || !email.includes('.')) {
      DialogUtility.alert('Please enter a valid email address!');
      return;
    }
    if (!phone || phone.length === 0) {
      DialogUtility.alert('Please enter a valid phone number!');
      return;
    }
    /*
    if (!company || company.length === 0) {
      DialogUtility.alert('Please enter your Company name!');
      return;
    }
    if (!name || name.length <= 1) {
      DialogUtility.alert('Please enter your name!');
      return;
    }
*/
    if (messageRef && messageRef.current) {
      msg = messageRef.current.value;
    }
    /*
    if (multiSelectServices && multiSelectServices.current) {
      services = JSON.stringify(multiSelectServices.current.value);
    }
    if (stateSelect && stateSelect.current) {
      location = stateSelect.current.value;
    }
      */
    /*
    if (location.length === 0) {
      DialogUtility.alert('Please select a service location.');
      return;
    }
    if (services.length === 0) {
      DialogUtility.alert('Please select at least one service.');
      return;
    }
    */
    let message = 'Contact me regarding Heat Stress and how to safely protect my employees';
    // message = `${name} US State: ${location} Services requested: ${services}`;
    message += `<br />${name}`;
    if (msg && msg.length > 0) {
      // message = `Name: ${name}<br />Company: ${company}<br />US State: ${location}\n<br />Services requested: ${services}<br />Customer Message: ${msg}`;
      message = `Name: ${name}<br />Customer Message: ${msg}`;
    }
    sendEmail(email, to, subject, message);
  };
  return (
    <div className="home-container">
      <EmbeddedForm />
      <div className="nav-bar-bg">
        <Navbar />
      </div>
      <div className="contact-page-wrapper">
        <h1 className="primary-heading">Do you have a question regarding Heat Stress and how to safely protect your employees?</h1>
        <div className="flex">
          <label>CONTACT OUR STAFF SEND AN EMAIL</label>
        </div>
        <div className="contact-form-wrapper" style={{ border: 'solid 2px', borderColor: '#78DA89', borderRadius: 10, backgroundColor: 'white' }}>
          <img src={kit} width={140} />
          <font color="red">*</font> indicates required fields
          <div className="flex">
            <label htmlFor="name">Name<font color="red">*</font></label>
            <TextBoxComponent
              value=""
              id="first"
              required
              name="first"
              placeholder="First"
              cssClass="e-outline"
              floatLabelType="Auto"
            />
            <TextBoxComponent
              value=""
              id="last"
              name="last"
              required
              placeholder="Last"
              cssClass="e-outline"
              floatLabelType="Auto"
            />
          </div>

          <div className="flex">
            <label htmlFor="email">Email<font color="red">*</font></label>
            <TextBoxComponent
              value=""
              id="email"
              required
              name="email"
              cssClass="e-outline"
              placeholder="Email"
              floatLabelType="Auto"
            />
            <label htmlFor="phone">Phone<font color="red">*</font></label>
            <TextBoxComponent
              value=""
              id="phone"
              required
              name="phone"
              placeholder="Phone"
              cssClass="e-outline"
              floatLabelType="Auto"
            />
          </div>
          {/*
          <div className="flex">
            <label htmlFor="company">Company Name<font color="red">*</font></label>
            <TextBoxComponent
              value=""
              id="company"
              required
              name="company"
              placeholder="Company"
              cssClass="e-outline"
              floatLabelType="Auto"
            />
          </div>
          <div className="flex my-custom-dropdown mt-4">
            <label htmlFor="name">What Location do you need service?{<font color="red">*</font></label>
            <DropDownListComponent
              ref={stateSelect}
              id="state-dropdown"
              dataSource={usStates} // The data source array
              required
              fields={fields} // The field mappings
              placeholder="Select a state"
              // Optional: enable filtering to easily search for states
              allowFiltering
            />
          </div>
          <div className="flex mt-4">
            <label htmlFor="name">What Service(s) do you need?<font color="red">*</font></label>
            <MultiSelectComponent
              ref={multiSelectServices}
              required
              placeholder="Choose Services"
              showSelectAll
              mode="CheckBox"
              id="service-dropdown"
              dataSource={usServices} // The data source array
              fields={fields} // The field mappings
            >
              <Inject services={[CheckBoxSelection]} />
            </MultiSelectComponent>
          </div>
            */}
          <div className="flex mt-4">
            <label htmlFor="name">Message</label>
            <TextAreaComponent
              ref={messageRef}
              rows={5}
              maxLength={200}
              id="message"
              title="message"
              placeholder="Message"
              cssClass="e-outline"
              floatLabelType="Auto"
              value={demo || ''}
            />
          </div>
          <div className="flex-end mr-4">
            <ButtonComponent cssClass="e-small" iconCss="e-icons e-save" style={{ float: 'right' }} onClick={submitEmail}>Submit</ButtonComponent>
          </div>
        </div>
      </div>
      <Footer1 />
    </div>
  );
};
export default Contact;
